import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ExpenseReceiptModalComponent } from '../expense-receipt-modal/expense-receipt-modal.component';

/**
 * Miniatura del comprobante en el listado. Muestra un guion cuando el gasto no
 * lleva comprobante adjunto, como en el diseño.
 *
 * La API entrega una URL pública al blob, así que basta con un `img`.
 *
 * Al pulsarla se abre el comprobante a tamaño grande: la miniatura sólo dice que
 * hay uno. El comportamiento vive aquí y no en la tabla para que sirva también
 * en el desglose de precio del detalle de servicio, que usa la misma pieza.
 */
@Component({
  selector: 'app-expense-receipt-thumbnail',
  templateUrl: './expense-receipt-thumbnail.component.html',
  styleUrls: ['./expense-receipt-thumbnail.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpenseReceiptThumbnailComponent {
  @Input() url: string | null = null;

  constructor(private readonly modal: NgbModal) {}

  protected open(): void {
    if (!this.url) {
      return;
    }

    const modalRef = this.modal.open(ExpenseReceiptModalComponent, {
      size: 'lg',
      centered: true,
      windowClass: 'expenses-receipt-modal',
      ariaLabelledBy: 'receipt-modal-title',
    });

    modalRef.componentInstance.url = this.url;
  }
}
